import { Layout } from "@jambushrushti/components/layout/Layout";
import { Button } from "@jambushrushti/components/ui/button";
import { Link, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Home, ArrowLeft, Search } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <Layout>
      <section className="bg-gradient-hero lotus-pattern flex min-h-[60vh] items-center py-24 lg:py-32">
        <div className="container mx-auto px-4">
          <div className="mx-auto max-w-lg text-center">
            <div className="animate-fade-up mx-auto mb-8 flex h-24 w-24 items-center justify-center rounded-full bg-primary/10">
              <span className="font-display text-4xl font-bold text-primary">
                404
              </span>
            </div>
            <h1 className="font-display animate-fade-up mb-4 text-3xl font-bold text-foreground delay-100 sm:text-4xl">
              Page Not Found
            </h1>
            <p className="animate-fade-up mb-8 text-muted-foreground delay-200">
              The path you seek does not exist. Perhaps the knowledge you're
              looking for lies elsewhere in our ecosystem.
            </p>
            <div className="animate-fade-up flex flex-wrap justify-center gap-4 delay-300">
              <Button variant="hero" asChild>
                <Link to="/">
                  <Home className="mr-2 h-4 w-4" />
                  Return Home
                </Link>
              </Button>
              <Button variant="outline" asChild>
                <Link to="/research">
                  <Search className="mr-2 h-4 w-4" />
                  Explore Research
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default NotFound;
